import {SignalStoreFeatureResult} from '@ngrx/signals';

function simplifyState<Input extends SignalStoreFeatureResult>(state: Input['state']) {
	return JSON.parse(JSON.stringify(state));
}

export type WithSyncableStateFeatureOptions = {
	simplifyStateFn: (state: any) => any;
	/** If true, the state will not be synced automatically.
	 * you	can sync the state manually by calling the `syncState` method.
	 */
	manualSync: boolean;
	/**
	 * If provided, the state will be cleared when the selected option lifecycle event is triggered:
	 * - 'logout': The state will be cleared when the user logs out.
	 *
	 * @default 'logout'
	 */
	clearOn: 'logout' | undefined;
};
export const defaultOptions: WithSyncableStateFeatureOptions = {
	simplifyStateFn: simplifyState,
	manualSync: false,
	clearOn: 'logout',
};
